import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";
import { Methods } from "../shared/methods";

@Injectable({
  providedIn: "root",
})
export class ContactsService {
  public mtds: Methods = new Methods();
  public url: string;
  public token;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + "/companycontact/";
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  save(json): Observable<any> {
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.update(json);
    }
  }

  create(json): Observable<any> {
    return this.petition(this.url + "new", json);
  }

  update(json): Observable<any> {
    return this.petition(this.url + "edit/" + json.id, json);
  }

  showAll(location_id, isquarter = false): Observable<any> {
    return this.petition(
      this.url + (isquarter ? "listbyquarter/" : "listbycompany/") + location_id
    );
  }

  

  showOne(id: any): Observable<any> {
    return this.petition(this.url + "detail/" + id);
  }

  listByCompany(id: any): Observable<any> {
    return this.petition(this.url + "listbycompany/" + id);
  }

  delete(id: any): Observable<any> {
    return this.petition(this.url + "remove/" + id);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));

    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this._http.post<any>(url, params, { headers: this.headers }).pipe(
      map((res) => {
        if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          // this._router.navigate(['/pages/lock']);
        }
        return res;
      })
    );
  }
}
